var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteToolFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_588)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.473 2.65702C15.2231 2.33498 13.9085 2.36475 12.6744 2.74304C11.4404 3.12133 10.3349 3.83341 9.48019 4.80061C8.62548 5.7678 8.05478 6.95246 7.83115 8.22368C7.60753 9.4949 7.73969 10.8032 8.21304 12.004L3.61403 15.897C3.26524 16.1918 2.98142 16.5557 2.78053 16.9658C2.57964 17.3759 2.46606 17.8233 2.44696 18.2795C2.42787 18.7358 2.50368 19.191 2.6696 19.6165C2.83551 20.042 3.08793 20.4283 3.41087 20.7512C3.73382 21.0741 4.12026 21.3264 4.54575 21.4923C4.97124 21.6581 5.42652 21.7338 5.88278 21.7146C6.33904 21.6954 6.78635 21.5817 7.19641 21.3807C7.60647 21.1798 7.97035 20.8959 8.26504 20.547L12.156 15.95C13.357 16.4241 14.6657 16.5569 15.9374 16.3336C17.2091 16.1104 18.3943 15.5398 19.362 14.6849C20.3296 13.8301 21.042 12.7243 21.4204 11.4898C21.7988 10.2553 21.8284 8.94028 21.506 7.69002C21.4606 7.51434 21.3686 7.35416 21.2399 7.22631C21.1111 7.09845 20.9503 7.00765 20.7743 6.96345C20.5983 6.91925 20.4136 6.92327 20.2397 6.97511C20.0658 7.02694 19.9091 7.12467 19.786 7.25802L16.741 10.565L14.444 9.72002L13.597 7.42002L16.906 4.38002C17.0402 4.25699 17.1386 4.09999 17.1908 3.92563C17.2431 3.75127 17.2473 3.56604 17.2029 3.3895C17.1585 3.21297 17.0673 3.05171 16.9388 2.92277C16.8103 2.79384 16.6494 2.70201 16.473 2.65702Z",
    fill: "#8C9FB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteToolFill);
export default __webpack_public_path__ + "static/media/mingcute_tool-fill.79c20b056080b79866a9c01d0083be41.svg";
export { ForwardRef as ReactComponent };